export const SLACK_COMPANY_OAUTH_URL = '/slack/company_oauth';
export const SLACK_USER_OAUTH_URL = '/slack/user_oauth';

export type URL_OAUTH_TYPES = typeof SLACK_COMPANY_OAUTH_URL | typeof SLACK_USER_OAUTH_URL;
